import { PillColor } from '../../../components/pill/Pill';
import { InvoiceStatus } from 'src/types/enums';

export const InvoiceStatusToText: Record<InvoiceStatus, string> = {
  [InvoiceStatus.Draft]: 'Ontwerp',
  [InvoiceStatus.Created]: 'Aangemaakt',
  [InvoiceStatus.Sent]: 'Verstuurd',
  [InvoiceStatus.Paid]: 'Betaald',
};

export const InvoiceStatusToColor: Record<InvoiceStatus, PillColor> = {
  [InvoiceStatus.Draft]: 'neutral',
  [InvoiceStatus.Created]: 'neutral',
  [InvoiceStatus.Sent]: 'positive',
  [InvoiceStatus.Paid]: 'positive',
};
